<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2019年12月25日 14:32:56 +0800
 * @最后修改时间: 2021-11-22 09:55:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimItemType\newClaimItemType.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_ClaimItemType_form_newTitle')"
    backgroundClass="white"
    :initData="claimItemType"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_item_type_name',
      'sequence',
      'status',
      'claim_item_type_description',
      'max_value',
      'min_value',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation @input="Changed = true">
        <v-row>
          <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
            <v-switch
              color="primary"
              class="ml-4"
              v-model="claimItemType.status"
              :label="
                claimItemType.status
                  ? $t('label_essweb_ClaimItemType_form_activeLabel')
                  : ''
              "
            ></v-switch>
          </v-col> -->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="claimItemType.claim_item_type_name"
              maxlength="200"
              @change="
                (valueArr) => {
                  claimItemType.claim_item_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_ClaimItemType_form_claimItemTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>

          <v-col md="3">
            <numberInputTextFiled
              v-model="claimItemType.sequence"
              maxlength="11"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
              "
              :label="$t('label_essweb_ClaimItemType_form_sequenceLabel')"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="claimItemType.claim_item_type_description"
              @change="
                (valueArr) => {
                  claimItemType.claim_item_type_description = valueArr;
                }
              "
              maxlength="500"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              v-model="claimItemType.min_value"
              :rules="$GetRules(['_Number_negative'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_minValueLabel')"
              type="number"
              :max="5"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :min="claimItemType.min_value"
              v-model="claimItemType.max_value"
              :rules="$GetRules(['_Number_negative'], [null])"
              :label="$t('label_essweb_ClaimItemType_form_maxValueLabel')"
              type="number"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimItemType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              mo.fish
              filled
              counter="500"
              dense
              single-line
              v-model="claimItemType.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toNew" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newClaimItemType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      Changed: false,
      isChanged: false,
      claimItemType: {
        claim_item_type_name: "",
        sequence: 1,
        status: 1,
        is_relate_to_cost_center: 0,
        claim_item_type_description: "",
        max_value: 0,
        min_value: 0,
        remarks: "",
      },
    };
  },
  watch: {},
  mounted() {
    const that = this;
    // this.claimItemType.claim_item_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.claimItemType.claim_item_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );

    // console.log(this.Changed);
    // console.log(this.$refs["form"])
    // console.log(this.$refs["form"].$el)
    // console.log(new FormData(this.$refs["form"].$el).entries())
    // let data={}
    // for (let [key, val] of new FormData(this.$refs["form"].$el).entries()) {
    //     Object.assign(data, { [key]: val })
    //   }
    //   console.log(data);
    //  this.$Sleep(2000).then(() =>{
    // that.$nextTick(that.Changed=false)
    // });
  },
  methods: {
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/add/",
        data: {
          claim_item_type_name: this.$transCommonLangKey(
            this.claimItemType.claim_item_type_name
          ),
          claim_item_type_description: this.$transCommonLangKey(
            this.claimItemType.claim_item_type_description
          ),
          max_value: this.claimItemType.max_value,
          min_value: this.claimItemType.min_value,
          status: this.claimItemType.status ? 1 : 0,
          sequence: this.claimItemType.sequence,
          remarks: this.claimItemType.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
